import { Icon, Link, Tag, Text } from "@growtherapy/sprout-ui";
import { faSparkles } from "@fortawesome/pro-solid-svg-icons";
import { getAppConfig } from "../../config";
import { twMerge } from "tailwind-merge";
import { useGetReadyAvsCountQuery } from "./useGetReadyAvsCountQuery";

type AvsCtaPillProps = {
  numSummaries: number;
  className?: string;
};

const providerDashboardUri = `${getAppConfig().providerOrigin}/dashboard`;

export function AvsCtaPill({ numSummaries, className }: AvsCtaPillProps) {
  if (!numSummaries) return;

  const sessionSummaryText =
    numSummaries === 1
      ? "session insights summary is available"
      : "session insights summaries are available";

  return (
    <Tag
      data-testid="avs-cta-pill"
      use="neutral"
      aria-label="Session insights summaries are available in your portal"
      className={twMerge(
        "normal-case bg-neutral-900 gap-2 w-fit flex items-center",
        className,
      )}
    >
      <Icon aria-hidden className="text-lilac-400" icon={faSparkles} />
      <Text as="span" variant="sm" className="text-neutral-100">
        {numSummaries} {sessionSummaryText} in
      </Text>{" "}
      <Link
        className="text-neutral-100 text-sm"
        href={providerDashboardUri}
        external
      >
        your portal
      </Link>
    </Tag>
  );
}

export function AvsCtaPillWrapper(props: Pick<AvsCtaPillProps, "className">) {
  const { data, loading } = useGetReadyAvsCountQuery();
  const numSummaries = data?.afterVisitSummariesReady?.totalReadyForReview ?? 0;

  if (loading) return;

  return <AvsCtaPill {...props} numSummaries={numSummaries} />;
}
